import { render, staticRenderFns } from "./NewQuestion.vue?vue&type=template&id=38b2e6d5&scoped=true&"
import script from "./NewQuestion.vue?vue&type=script&lang=js&"
export * from "./NewQuestion.vue?vue&type=script&lang=js&"
import style0 from "./NewQuestion.vue?vue&type=style&index=0&id=38b2e6d5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b2e6d5",
  null
  
)

export default component.exports